module.exports = __webpack_public_path__ + "static/huggingface-logo-20e1b1ce1ac8f14670c1c7c2028a02cf.png";